import { render, staticRenderFns } from "./attendant.vue?vue&type=template&id=1b966c5c&"
import script from "./attendant.vue?vue&type=script&lang=js&"
export * from "./attendant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports